import React from "react";
import { Form, Button, Message, Table, Checkbox } from "semantic-ui-react";
import InlineError from "../messages/InlineError";
import { ERR_TEXTBOX_NOT_FILLED } from "../../ErrorMessages";

class UserProfileForm extends React.Component {
  state = {
    data: {
      themeOption: this.props.userAccount.acctTheme === 1,
      searchBySsn: this.props.userAccount.mastSearchBySSN,
    },
    errors: {},
  };

  onThemeOptionChange = (e, cont) => {
    const { data } = this.state;
    data.themeOption = cont.checked;
    this.setState({ data });
  };

  onSearchBySsnChange = (e, cont) => {
    const { data } = this.state;
    data.searchBySsn = cont.checked;
    this.setState({ data });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.data);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.props.submit(this.state.data);
    }
  };

  validate = (data) => {
    const errors = {};
    if (data.themeOption === undefined) {
      errors.themeOption = ERR_TEXTBOX_NOT_FILLED;
      const element = document.getElementById("themeOption");
      if (element) element.focus();
    }
    return errors;
  };

  render() {
    const { errors, data } = this.state;
    return (
      <Form onSubmit={this.onSubmit} loading={this.props.loading}>
        {errors.global && (
          <Message negative>
            <Message.Header>Something went wrong</Message.Header>
            <p>{errors.global}</p>
          </Message>
        )}
        <Table className="my-profile-table">
          <Table.Body>
            <Table.Row>
              <Table.Cell width={8}>
                <label
                  style={{ fontSize: "14px" }}
                  className="font-family"
                  htmlFor="themeOption"
                >
                  Switch to new theme
                </label>
              </Table.Cell>
              <Table.Cell width={8}>
                <Form.Field error={!!errors.themeOption}>
                  <Checkbox
                    toggle
                    name="themeOption"
                    id="themeOption"
                    checked={data.themeOption}
                    onChange={this.onThemeOptionChange}
                  />
                  {errors.themeOption && (
                    <Table.Row>
                      <Table.Cell colSpan={3}>
                        <InlineError text={errors.themeOption} />
                      </Table.Cell>
                    </Table.Row>
                  )}
                </Form.Field>
              </Table.Cell>
              {/* <Table.Cell>
                <Button primary>Submit</Button>
              </Table.Cell> */}
            </Table.Row>
            {/* <Table.Row>
              <Table.Cell>
                <label
                  style={{ fontSize: "14px" }}
                  className="font-family"
                  htmlFor="themeOption"
                >
                  Search by SSN
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Field error={!!errors.searchBySsn}>
                  <Checkbox
                    toggle
                    name="searchBySsn"
                    id="searchBySsn"
                    checked={data.searchBySsn}
                    onChange={this.onSearchBySsnChange}
                  />
                  {errors.searchBySsn && (
                    <Table.Row>
                      <Table.Cell colSpan={3}>
                        <InlineError text={errors.searchBySsn} />
                      </Table.Cell>
                    </Table.Row>
                  )}
                </Form.Field>
              </Table.Cell>
            </Table.Row> */}
            <Table.Row>
              <Table.Cell colSpan={2} className="text-center">
                <Button primary className="margin-bottom-10">
                  Submit
                </Button>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Form>
    );
  }
}

export default UserProfileForm;



// WEBPACK FOOTER //
// ./src/components/forms/UserProfileForm.js